<template>
    <CardPage :section="4" :page="14" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            I want you to remember that you deserve to Get Your Life!
        </p>
        <p>
            Our House of LifeSkills mantra is, repeat it with me:
        </p>
        <p class="font-weight-bold">
            Pride: I deserve it! I can have it! And I know how to get it!
        </p>
        <ResponsiveImage
            :src="require('@/assets/poses/Trans-Poses_0003_Queenie_talking.png')"
            alt="Queenie"
            layout="align-center justify-end mt-3"
            flex="xs4"
        ></ResponsiveImage>
    </CardPage>
</template>

<script>
export default {
    methods: {
        finish() {
            this.$store.set('section4/complete', true);
        }
    }
};
</script>
